import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import styles from '../../pages/Dashboard.module.css';

const TimesheetEmployeeView = ({
    groupedByEmployee,
    getHoursColor,
    handleEdit,
    handleDelete
}) => {
    return (
        <div>
            {Object.entries(groupedByEmployee).map(([empName, data]) => (
                <div key={empName} style={{
                    marginBottom: '2rem',
                    background: 'var(--color-surface)',
                    borderRadius: 'var(--border-radius-lg)',
                    padding: '1.5rem',
                    boxShadow: 'var(--shadow-light)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FontAwesomeIcon icon={faUserFriends} style={{ color: 'var(--color-primary)' }} />
                            {empName}
                        </h4>
                        <span style={{
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            color: 'var(--color-primary)',
                            background: 'rgba(164, 198, 57, 0.1)',
                            padding: '8px 16px',
                            borderRadius: '8px'
                        }}>
                            Total: {data.totalHours}h
                        </span>
                    </div>
                    <table className={styles.dataTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Chantier</th>
                                <th>Heures</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.entries.map(entry => (
                                <tr key={entry.id}>
                                    <td>{new Date(entry.date).toLocaleDateString('fr-FR')}</td>
                                    <td style={{ fontWeight: 'bold' }}>{entry.expand?.chantier?.name || '-'}</td>
                                    <td>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: getHoursColor(entry.hours),
                                            padding: '4px 8px',
                                            background: getHoursColor(entry.hours) + '15',
                                            borderRadius: '6px'
                                        }}>
                                            {entry.hours}h
                                        </span>
                                    </td>
                                    <td style={{ color: 'var(--color-text-light)', fontStyle: 'italic' }}>
                                        {entry.description || '-'}
                                    </td>
                                    <td className={styles.actions}>
                                        <button className={styles.edit} onClick={() => handleEdit(entry)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className={styles.delete} onClick={() => handleDelete(entry.id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
            {Object.keys(groupedByEmployee).length === 0 && (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                    Aucune donnée à afficher
                </div>
            )}
        </div>
    );
};

export default TimesheetEmployeeView;
